import { Component, inject } from '@angular/core';
import { TbsStepsModule } from '@ngx-terabase/ui/steps';

import { MissionResultComponent } from '../mission-result/mission-result.component';
import {
  MissionCreationResult,
  NewMissionComponent,
} from '../new-mission/new-mission.component';
import {
  UploadMissionComponent,
  MissionUploadResult,
} from '../upload-mission/upload-mission.component';
import { TbsNotificationModule } from '@ngx-terabase/ui/notification';
import { UserContextService } from 'src/app/services/user-context.service';
import { TbsButtonModule } from '@ngx-terabase/ui/button';
import { S3UrlUploadComponent } from '../s3-url-upload/s3-url-upload.component';

@Component({
  selector: 'app-upload',
  imports: [
    MissionResultComponent,
    NewMissionComponent,
    UploadMissionComponent,
    S3UrlUploadComponent,
    TbsNotificationModule,
    TbsButtonModule,
  ],
  templateUrl: './upload.component.html',
  styleUrl: './upload.component.scss',
  standalone: true,
})
export class UploadComponent {
  public step = 0;
  public missionCreationResult: MissionCreationResult | null = null;
  public missionUploadResult: MissionUploadResult | null = null;
  public isUserFromTerabaseCompany =
    inject(UserContextService).isFromTerabaseCompany();

  public uploadView: 'select' | 's3Url' | 'upload' = 'select';

  public stepChanged(event: number): void {
    this.step = event;
  }

  onMissionCreate(event: MissionCreationResult) {
    this.uploadView = this.isUserFromTerabaseCompany ? 'select' : 'upload';
    this.step += 1;
    this.missionCreationResult = event;
  }

  onUploadFinish(event: MissionUploadResult) {
    this.step += 1;
    this.missionUploadResult = event;
  }

  onS3UploadFinish() {
    this.step += 1;
    this.missionUploadResult = {
      numberOfMapUploads: 0,
      numberOfOtherUploads: 0,
      numberOfPanoramaUploads: 0,
    };
  }
}
